import { createContext } from "react"

interface AuthContextState {
  token: string | undefined
  setToken: React.Dispatch<React.SetStateAction<string | undefined>>
  adb2cToken: string | undefined
  setAdb2cToken: React.Dispatch<React.SetStateAction<string | undefined>>
  unsetTokens(): void
}

const initialValue: AuthContextState = {
  token: undefined,
  setToken: () => {},
  adb2cToken: undefined,
  setAdb2cToken: () => {},
  unsetTokens: () => {}
}

export const AuthContext = createContext(initialValue)
